import { useState } from 'react'
import { DossSignalType, useDossSignals } from '~/common/hooks/useDossSignals'
import { ToggleableSearchField } from '../shared/ToggleableSearchField'

/**
 * Search input component for filtering forms on the forms home page.
 */
export function FormsSearchInput() {
  const { dispatch } = useDossSignals()
  const [value, setValue] = useState('')

  const handleChange = (newValue?: string) => {
    setValue(newValue ?? '')
    dispatch(DossSignalType.FORMS_SEARCH_QUERY_CHANGED, { query: newValue })
  }

  return (
    <ToggleableSearchField
      onSearch={handleChange}
      searchString={value}
      showPlaceholderWhenCollapsed
    />
  )
}
